import React, { HTMLAttributes } from 'react';
import styled from 'styled-components/macro';
import { ClassName, Label } from 'interfaces/shared';
import { ClassNameUtil } from 'utils/className';

export interface IconProps extends ClassName, Label {
  color?: 'green' | 'red' | 'paleSky' | 'black' | '';
  size?: string;
  roundBorder?: boolean;
  icon: string;
  iconLeft?: boolean;
  iconClassName?: string;
  faBase?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  baseClass?: string;
  id?: HTMLAttributes<'i'>['id'];
}

const StyledIcon = styled.i`
  font-size: ${({ theme }) => theme.iconSize2};
  color: ${({ theme }) => theme.iconColor01};
  width: auto !important;

  &.fa-envelope {
    color: ${({ theme }) => theme.iconColor02};
  }

  &.rotate {
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

  &.large:before {
    font-size: 40px;
  }

  &.green {
    color: ${({ theme }) => theme.iconColor02};
  }

  &.red {
    color: ${({ theme }) => theme.tag02};
  }

  &.paleSky {
    color: ${({ theme }) => theme.iconColor09};
  }

  &.black {
    color: ${({ theme }) => theme.iconColor07};
  }

  &.clickable {
    cursor: pointer;
  }
`;

export const Icon = ({
  className = '',
  icon = '',
  faBase = 'fas',
  color = '',
  size = '',
  roundBorder = false,
  baseClass = 'portal-icon',
  onClick,
  id,
}: IconProps) => {
  const iconClassName = ClassNameUtil.create()
    .add(baseClass)
    .add(className)
    .add(`${faBase} fa-${icon} `, !!icon)
    .add(color)
    .add(size)
    .add(`${baseClass}__round-border`, roundBorder);

  return <StyledIcon id={id} className={iconClassName.getClassName()} onClick={onClick} />;
};
